/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * DSV Public API
 * DSV Public API
 * OpenAPI spec version: 1.2.3
 */

export type EventRegistrationBillingMethod = typeof EventRegistrationBillingMethod[keyof typeof EventRegistrationBillingMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventRegistrationBillingMethod = {
  EMAIL: 'EMAIL',
  LETTER: 'LETTER',
} as const;
